import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { I18nString } from "@/utils/i18n-types";
import { RaffleConditionDoneIcon, RaffleConditionPendingIcon } from "./icons";
import { useRafflePageContext } from "./RafflePageContext";
import cls from "./styles.module.scss";

type ConditionItem = {
  isMet: boolean;
  labelKey: I18nString;
};

export const ParticipationConditions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { search } = useLocation();
  const { raffle } = useRafflePageContext();
  const { conditions } = raffle.me;

  if (raffle.drawn_at) {
    return null;
  }

  const items: ConditionItem[] = [
    {
      isMet: Boolean(conditions?.has_goal_this_week),
      labelKey: "raffle.conditions.takeGoal",
    },
    {
      isMet: Boolean(conditions?.has_completed_order_this_week),
      labelKey: "raffle.conditions.completeOrder",
    },
  ];

  if (items.every((item) => item.isMet)) {
    return null;
  }

  const shouldShowGoalButton = !conditions?.has_goal_this_week;

  return (
    <div className={cls.conditionsSection}>
      <div className={cls.conditionsCard}>
        {items.map((item) => (
          <div key={item.labelKey} className={cls.conditionRow}>
            {item.isMet ? (
              <RaffleConditionDoneIcon />
            ) : (
              <RaffleConditionPendingIcon />
            )}
            <span className={cls.conditionLabel}>{t(item.labelKey)}</span>
            {item.isMet && (
              <span className={cls.conditionStatus}>
                {t("raffle.conditions.done")}
              </span>
            )}
          </div>
        ))}
      </div>
      {shouldShowGoalButton && (
        <button
          type="button"
          className={cls.conditionsGoalButton}
          onClick={() =>
            navigate({
              pathname: "/apps/goals",
              search,
            })
          }
        >
          {t("raffle.conditions.toMyGoal")}
        </button>
      )}
    </div>
  );
};
